<template>
  <header>
		<div :class="{'nav-inner': true, scrolled: hasScrolled}">
			<router-link to="/overview" class="name text-name">Lucas Drummond</router-link>
			<div class="nav-links">

				<!-- Projects Route Link -->
				<router-link 
					:class="['link', 'text-navlink', {'router-link-active': routeActive('project')}]" 
					to="/overview"
					:aria-current="routeActive('project') ? 'page' : false"
				>
					Projects
				</router-link>

				<!-- Projects Route Link -->
				<!-- <router-link 
					:class="['link', 'text-navlink', {'router-link-active': routeActive('illustration')}]" 
					to="/illustration"
					:aria-current="routeActive('illustration') ? 'page' : false"
				>
					Illustration / Sketches
				</router-link> -->

				<!-- About Route Link -->
				<router-link 
					class="link text-navlink" 
					to="/about"
					:aria-current="routeActive('about') ? 'page' : false"
				>
					About
				</router-link>

				<!-- Contact Link -->
				<a class="link text-navlink" :href="'mailto:' + email"> Contact</a>
			</div>
		</div>
  </header>
</template>

<script>

export default {
	name: 'Navblock',
	props: ['siteMeta'],
	data() {
		return {
			hasScrolled: false,
      email: this.siteMeta.email || 'ldrummond.contact@gmail.com',
		}
	},
	created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		routeActive(routeName) {
			return this.$route.name === routeName; 
		},
		handleScroll() {
			if(window.scrollY <= 1) {
				this.hasScrolled = false;
			} else {
				this.hasScrolled = true;
			}
		}
	},
}
</script>

<style lang="sass">
@import '../assets/partials/_vars'

.nav-inner
	width: 100%
	background-color: $secondary-color // $nav-color
	border-radius: 0 0 20px 20px
	box-shadow: 0px 0px 5px 5px rgb(52 174 21)
	padding: 12px 1/28 * 100vw
	height: $nav-height
	
	.name
		width: 100%
		display: block
		margin-bottom: 4px

	.nav-links
		width: 100%
		+flex-center
		justify-content: space-between
		letter-spacing: 0.01em
		height: 3rem
		z-index: 1

		.link
			// position: relative
			transition: color 150ms ease, opacity 333ms ease

			&.router-link-active,	&:hover
				color: $tertiary-color
				&::before
					content: "→"


+after-sm-mobile
	.nav-inner
		display: flex
		justify-content: space-between
		height: auto

		.name 
			width: auto

		.nav-links 
			width: auto

			.link 
				margin-left: 2rem

+after-sm-desktop
	.nav-inner
		margin-top: 8px
		padding: 24px
		height: auto
		display: block

		.name 
			margin-bottom: 24px

		.nav-links
			display: flex
			flex-direction: column
			align-items: flex-start
			height: auto

			.link
				transition: color 150ms ease, opacity 333ms ease
				margin-bottom: 0.3rem
				margin-left: 0

				&.router-link-active,	&:hover
					color: $tertiary-color
					.svg-arrow
						opacity: 1

</style>
